import { ButtonProps, IconProps, Text } from '@chakra-ui/react';
import { forwardRef } from 'react';
import Button from '~/components/Button';

interface Props extends ButtonProps {
  icon: any;
  iconColor?: string;
  iconProps?: IconProps;
  trackId?: string;
}

const ResponsiveIconButton = forwardRef<HTMLButtonElement, Props>(
  ({ children, icon: Icon, iconColor, iconProps, trackId, ...props }, ref) => (
    <Button
      rounded={{ base: 'sm', md: 'full' }}
      paddingX={{ base: 0, md: 4 }}
      ref={ref}
      track-id={trackId}
      {...props}
    >
      <Text
        display={{ base: 'none', md: 'inline-block' }}
        fontSize="14px"
        fontWeight="medium"
      >
        {children}
      </Text>
      <Icon
        display={{ base: 'inline-block', md: 'none' }}
        marginLeft={{ base: 0, md: 2 }}
        boxSize="24px"
        color={iconColor || 'white'}
        {...iconProps}
      />
    </Button>
  ),
);

export default ResponsiveIconButton;
